import { useEffect, useState } from "react";
import { Menu } from "../../components/menu/menu";
import { Story, StoryPositin } from "../../components/story/story";
import { bemCN } from "../../config/bem-classname";
import { Story as StoryClass } from "../../view-models/story";
import "./stories-page.scss";
import { storyService } from "../../services/story-service";
import { Modal } from "../../ui/modal/modal";
import { Button, ButtonColors, ButtonSizes } from "../../ui/button/button";
import { ReactComponent as PlayIcon } from "../../shared/images/svg/play.svg";
import { ReactComponent as CrossIcon } from "../../shared/images/svg/cross.svg";
import { links } from "../../config/links";
import { useNavigate } from "react-router";
const storiesPageCn = bemCN("stories-page");

export const StoriesPage = () => {
  const [activeId, setActiveId] = useState(-1);
  const [stories, setStories] = useState<StoryClass[]>();
  const navigate = useNavigate();

  const [isShowModal, setIsShowModal] = useState(false);

  useEffect(() => {
    const detectOS = () =>
      /android/i.test(navigator.userAgent)
        ? "Android"
        : /iPad|iPhone|iPod/.test(navigator.userAgent)
          ? "iOS"
          : "Неустановленная ОС";
    if (detectOS() == "iOS") {
      if (!window.matchMedia("(display-mode: standalone)").matches) {
        console.log("В браузере");
        setIsShowModal(true);
      }
    }
  }, [1]);

  const onClickStory = (id: number) => {
    setActiveId(id);
  };

  const getStories = () => {
    storyService.getStories().then((res: StoryClass[]) => {
      setStories(res);
    });
  };

  useEffect(() => {
    getStories();
  }, [1]);

  return (
    <div className={storiesPageCn()}>
      <Menu title="Книги" />
      <div className={storiesPageCn("stories")}>
        {stories &&
          stories.map((story: StoryClass, index: number) => (
            <Story
              key={story.id}
              story={story}
              position={index % 2 == 0 ? StoryPositin.left : StoryPositin.right}
              isActive={activeId == story.id ? true : false}
              onClickStory={onClickStory}
            />
          ))}
      </div>
      <Modal
        id="iOSModal"
        isShowDialog={isShowModal}
        setIsShowDialog={setIsShowModal}
      >
        <div>
          <Button
            icon={<CrossIcon />}
            color={ButtonColors.transition}
            size={ButtonSizes.small}
            onClick={() => setIsShowModal(false)}
          />
          <Button
            icon={<PlayIcon />}
            color={ButtonColors.transition}
            size={ButtonSizes.small}
            onClick={() => {
              setIsShowModal(false);
              navigate(links.instruction);
            }}
          />
          <p>Как установить приложение</p>
        </div>
      </Modal>
    </div>
  );
};
